<!-- <div class="container"> -->
    <!-- <div class="container-change-vehicle">
      <button mat-flat-button class="change-vehicel">Change Vehicle</button>
    </div> -->
    <!-- <app-change-vehcile></app-change-vehcile> -->
    <!-- <div class="title-section font-16 navy-blue-color">
      <p>{{ title }}</p>
    </div>
    <form id="subsForm" [formGroup]="subscriptionForm">
      <mat-horizontal-stepper #stepper linear (selectionChange)="onStepChange($event)">
        <ng-template matStepperIcon="edit"> </ng-template>
        <ng-template matStepperIcon="active"> </ng-template>
        <ng-template matStepperIcon="done"> </ng-template>
        <ng-template matStepperIcon="number"> </ng-template>
        <mat-step formGroupName="packageDetails" [stepControl]="subscriptionForm.get('packageDetails')"
          label="Select  Subscription">
          <ng-template matStepLabel>
            <div id="subsSelect" class="stepper-label">Select Subscription</div>
          </ng-template>
          <app-gdo-select-subscription [currentSelectedPackage]="currentSelectedPackage" [subsForm]="subscriptionForm"
            [title]="title"></app-gdo-select-subscription>
        </mat-step>
        <mat-step formGroupName="contactDetails" [stepControl]="subscriptionForm.get('contactDetails')"
          label="Subscription Contact Information">
          <ng-template matStepLabel>
            <div id="contactInfo" class="stepper-label">Subscription Contact Information</div>
          </ng-template>
          <app-gdo-subscription-contact-information [subsForm]="subscriptionForm"></app-gdo-subscription-contact-information>
        </mat-step>
        <mat-step formGroupName="paymentDetails" [stepControl]="subscriptionForm.get('paymentDetails')"
          label="Payment Method">
          <ng-template matStepLabel>
            <div id="paymentMethod" class="stepper-label">Payment Method</div>
          </ng-template>
          <app-gdo-subscription-payment-method [subsForm]="subscriptionForm"></app-gdo-subscription-payment-method>
        </mat-step>
        <mat-step *ngIf="title === 'Purchase Subscription' && showResetPin" formGroupName="pinDetails"
          [stepControl]="subscriptionForm.get('pinDetails')" label="Create PIN">
          <ng-template matStepLabel>
            <div id="createPin" class="stepper-label">Create PIN</div>
          </ng-template>
          <app-gdo-subscription-create-pin [subsForm]="subscriptionForm"></app-gdo-subscription-create-pin>
        </mat-step>
        <mat-step label="Summary">
          <ng-template matStepLabel>
            <div id="summary" class="stepper-label">Summary</div>
          </ng-template>
          <app-gdo-subscription-summary [parentSubject]="parentSubject" [title]="title" [subsForm]="subscriptionForm">
          </app-gdo-subscription-summary>
        </mat-step>
      </mat-horizontal-stepper>
    </form> -->
  <!-- </div> -->




<!-- Stepper container -->
  <div class="container">

    <!--Title of Compoients that will be in view   -->
    <div class="title-section font-16 navy-blue-color">
      <p>{{ title }}</p>
    </div>

    <!-- Subscription form start  -->
    <form id="subsForm" [formGroup]="subscriptionForm">

      <!-- Stepper start -->
      <mat-horizontal-stepper #stepper linear (selectionChange)="onStepChange($event)">

        <!-- Select Subscription Step -->
        <mat-step state="doneIcon" formGroupName="packageDetails" [stepControl]="subscriptionForm.get('packageDetails')">
          <ng-template matStepLabel><div  class="stepper-label">Select Subscription</div></ng-template>
          <!--Component: gdo-select-subscription -->
          <app-gdo-select-subscription
            [currentSelectedPackage]="currentSelectedPackage"
            [subsForm]="subscriptionForm" [title]="title"></app-gdo-select-subscription>
        </mat-step>

        <!-- Subscription Contact Information  Step -->
        <mat-step formGroupName="contactDetails" [stepControl]="subscriptionForm.get('contactDetails')">
         <ng-template matStepLabel><div  class="stepper-label">Subscriber Contact Information</div></ng-template>
          <!-- Component: -->
          <!-- <app-gdo-subscription-contact-information [subsForm]="subscriptionForm"></app-gdo-subscription-contact-information> -->
          <app-gdo-subscription-contact-information [subsForm]="subscriptionForm"></app-gdo-subscription-contact-information>
        </mat-step>

        <!-- Payment Method Step -->
        <mat-step formGroupName="paymentDetails" [stepControl]="subscriptionForm.get('paymentDetails')">
          <ng-template matStepLabel><div class="stepper-label">Payment Method</div></ng-template>
         <!-- Component: -->
         <app-gdo-subscription-payment-method [subsForm]="subscriptionForm"></app-gdo-subscription-payment-method>
        </mat-step>


        <!-- Create Pin Step -->
        <mat-step *ngIf="title === 'Purchase Subscription' && showResetPin" formGroupName="pinDetails" [stepControl]="subscriptionForm.get('pinDetails')">
          <ng-template matStepLabel><div class="stepper-label">Create Pin</div></ng-template>
         <!-- Component: -->
         <app-gdo-subscription-create-pin [subsForm]="subscriptionForm"></app-gdo-subscription-create-pin>
        </mat-step>


        <!-- Summary Step -->
        <mat-step>
          <ng-template matStepLabel><div class="stepper-label">Summary</div></ng-template>
          <!-- Component: -->
          <app-gdo-subscription-summary [parentSubject]="parentSubject" [title]="title" [subsForm]="subscriptionForm">
          </app-gdo-subscription-summary>
        </mat-step>


           <!-- This is the done icon that will appear on each tab after completion -->
        <ng-template matStepperIcon="doneIcon"><mat-icon>done</mat-icon></ng-template>
      </mat-horizontal-stepper> <!-- stepper ends -->

      <!-- susbcription Form ends -->
    </form>

  </div>
